import { PureComponent, ReactNode } from 'react';
import { crossIcon, validTickIcon } from '../../../common/Icons';

type Props = {
    isValid: boolean;
    text: string;
};

class ValidationItem extends PureComponent<Props> {
    render(): ReactNode {
        const { isValid, text } = this.props;

        return (
            <div className="flex space-x-8 items-center">
                {isValid
                    ? validTickIcon(
                          `w-10 h-10 ${
                              isValid
                                  ? 'fill-darwin-accent-sulphur-green-500'
                                  : 'fill-darwin-status-warning-500'
                          }`,
                      )
                    : crossIcon(
                          `w-10 h-10 ${
                              isValid
                                  ? 'fill-darwin-accent-sulphur-green-500'
                                  : 'fill-darwin-status-warning-500'
                          }`,
                      )}
                <span
                    className={
                        isValid
                            ? 'text-darwin-accent-sulphur-green-500 text-13'
                            : 'text-darwin-status-warning-500 text-13'
                    }
                >
                    {text}
                </span>
            </div>
        );
    }
}

export default ValidationItem;
